import { z } from 'zod';

export const DiscountsSchema = z.object({});
